import { Cookie } from '@phosphor-icons/react';

export default Cookie;
